import React, {useEffect, useRef} from "react";
import "./about.css";
import SocialContact from '../../common/social-contact/index'
import programming from "../../../assets/programming.gif"

import { init } from "ityped";

const About = () => {
  const textRef = useRef();

  useEffect(() => {
    init(textRef.current, {
      showCursor: true,
      backDelay: 1500,
      backSpeed:60,
      strings: ["I love experimenting with the web.", "I am a MERN Stack Developer."],
    });
  }, []);

  return (
    <div className="about">
      <div className="about-top">
        <div className="about-info">
          Hello There 👋, I am <br />
          <span className="info-name">Ankit Choudhary</span>.
          <br /> <span className="text-type" ref={textRef}></span>
        </div>
        <div className="about-photo">
          <img
            className="picture"
            src={programming}
            alt="about"
          />
        </div>
      </div>
      <div className="about-bottom">
        <SocialContact/>
      </div>
    </div>
  );
};

export default About;
